import camelcaseKeys from 'camelcase-keys'
import { create } from 'zustand'

import { executeGet } from '@/services/lukita'
import type { ProjectScreening, ProjectScreeningDTO } from './types'

interface ProjectScreeningStoreActions {
  reset: () => void
  setScreening: (screening: ProjectScreeningDTO) => void
}

interface ProjectScreeningStoreLoaders {
  fetchScreening: (slug: string) => Promise<void>
}

interface ProjectScreeningStore {
  loading: boolean
  screening: ProjectScreening | null
  actions: ProjectScreeningStoreActions
  loaders: ProjectScreeningStoreLoaders
}

export const useProjectScreeningStore = create<ProjectScreeningStore>(
  (set, get, store) => ({
    loading: true,
    screening: null,
    actions: {
      reset: () => set(store.getInitialState()),
      setScreening: (dto) =>
        set({
          screening: camelcaseKeys(dto, { deep: true }) as ProjectScreening,
          loading: false,
        }),
    },
    loaders: {
      fetchScreening: async (slug) => {
        set({ loading: true })
        const response = await executeGet(`/projects/${slug}/screening`)
        get().actions.setScreening(await response.json())
      },
    },
  }),
)
